var _excluded = ["alwaysShowCalendar", "fixedPosition", "onInputChange"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import moment from "moment";
import { isString, isNil } from "lodash-es";
import { addMonths, startOfDay, endOfDay } from "date-fns";
import { useRect } from "../../helpers/hooks";
import { onEnter } from "../../helpers";
import { useEventListener, useId } from "../../helpers/hooks";
import { Label } from "../label/Label";
import Input from "../../forms/input/Input";
import { CalendarDisplay } from "./CalendarDisplay";
import { inferDate, isValidDateFormat } from "./parseDate";
import { DAY_FORMAT } from "./constants";
import { toDate, getHoursAndMinutes, isWithinRange } from "./utils";
import { TimeSelect } from "./TimeSelect";
export var MAX_OPTIONS_HEIGHT = 254;
var INPUT_HEIGHT = 38;
var BORDER_HEIGHT = 1;
export var MAX_RESULTS_BOX_HEIGHT = MAX_OPTIONS_HEIGHT + INPUT_HEIGHT + BORDER_HEIGHT * 2;
function formatDate(date) {
  return date.format(DAY_FORMAT);
}
function getMinutes(date) {
  return date.getHours() * 60 + date.getMinutes();
}
export function DatePicker(_ref) {
  var _useRect;
  var _ref$alwaysShowCalend = _ref.alwaysShowCalendar,
    alwaysShowCalendar = _ref$alwaysShowCalend === void 0 ? false : _ref$alwaysShowCalend,
    _ref$fixedPosition = _ref.fixedPosition,
    fixedPosition = _ref$fixedPosition === void 0 ? false : _ref$fixedPosition,
    _ref$onInputChange = _ref.onInputChange,
    onInputChange = _ref$onInputChange === void 0 ? function () {} : _ref$onInputChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var hasDate = moment(props.date).isValid() && !isNil(props.date);
  var innerId = useId();
  var labelId = props.id || "tui-date-picker-".concat(innerId);
  var dateInputRef = useRef();
  var calendarRef = useRef();
  var _useState = useState(function () {
      return hasDate ? props.date.toDate() : new Date();
    }),
    _useState2 = _slicedToArray(_useState, 2),
    date = _useState2[0],
    setDate = _useState2[1];
  var _useState3 = useState(function () {
      return hasDate ? formatDate(props.date) : props.date;
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var _useState5 = useState(function () {
      return hasDate ? getMinutes(props.date.toDate()) : 0;
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    minutes = _useState6[0],
    setMinutes = _useState6[1];
  var _useState7 = useState(alwaysShowCalendar),
    _useState8 = _slicedToArray(_useState7, 2),
    showCalendar = _useState8[0],
    setShowCalendarInternal = _useState8[1];
  function setShowCalendar(newValue) {
    if (alwaysShowCalendar) return;
    setShowCalendarInternal(newValue);
  }
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    previousValue = _React$useState2[0],
    setPreviousValue = _React$useState2[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    hasFocus = _useState0[0],
    setHasFocus = _useState0[1];
  var minDate = startOfDay(toDate(props.minDate));
  var maxDate = endOfDay(toDate(props.maxDate));
  var rect = (_useRect = useRect(dateInputRef)) !== null && _useRect !== void 0 ? _useRect : {};
  useLayoutEffect(function () {
    if (!fixedPosition) return;
    var inputMargin = 4;
    var styles = {
      top: "".concat(rect.top + rect.height + inputMargin, "px"),
      left: "".concat(rect.left, "px"),
      right: "".concat(rect.right, "px"),
      transform: null,
      position: "fixed",
      height: null
    };
    var collidesWithBottom = window.innerHeight <= rect.bottom + MAX_RESULTS_BOX_HEIGHT;
    if (collidesWithBottom) {
      styles.transform = "translateY(-100%) translateY(-".concat(rect.height + inputMargin * 2, "px)");
      styles.height = "".concat(MAX_OPTIONS_HEIGHT, "px");
    }
    Object.entries(styles).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      calendarRef.current.style[key] = value;
    });
  }, [rect.top, rect.left, rect.right, rect.width, rect.height, fixedPosition]);
  useEventListener(calendarRef.current, "focusout", function (event) {
    if (!calendarRef.current.contains(event.relatedTarget)) {
      setShowCalendar(false);
    }
  });
  useEffect(function () {
    setDate(hasDate ? props.date.toDate() : new Date());
    setValue(hasDate ? formatDate(props.date) : props.date);
    setMinutes(hasDate ? getMinutes(props.date.toDate()) : "");
  }, [props.date]);
  function _onChange(date) {
    if (date === null) {
      if (props.date !== null) props.onChange(null, false);
      return;
    }
    if (date.isSame(props.date, props.showTime ? "minute" : "day")) return;
    var isOutOfRange = !isWithinRange(toDate(date), toDate(props.minDate), toDate(props.maxDate));
    props.onChange(date, isOutOfRange);
  }
  function updateDate(day) {
    var fromCalendar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!day && props.optional && isString(value) && value.trim() === "") {
      _onChange(null);
    } else if (fromCalendar || isString(value) && isValidDateFormat(value)) {
      var newDay = day || isString(value) && inferDate(value, props.date.toDate());
      var newDate = moment(newDay);
      newDate.set(getHoursAndMinutes(minutes));
      _onChange(newDate);
      setValue(formatDate(moment(newDay)));
      setDate(newDay);
    } else {
      setValue(formatDate(props.date));
      setDate(props.date.toDate());
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "tui-date-picker ".concat(alwaysShowCalendar ? "tui-date-picker--inline-cal" : ""),
    tabIndex: -1,
    onFocus: function onFocus() {
      return setHasFocus(true);
    },
    onBlur: function onBlur() {
      return setHasFocus(false);
    }
  }, props.label && /*#__PURE__*/React.createElement(Label, {
    htmlFor: labelId,
    required: props.required
  }, props.label), /*#__PURE__*/React.createElement("div", {
    className: "tui-date-picker__inputs"
  }, /*#__PURE__*/React.createElement(Input, {
    id: labelId,
    ref: dateInputRef,
    value: isString(value) ? value : "",
    disabled: props.disabled,
    onFocus: function onFocus() {
      setShowCalendar(true);
      if (hasDate) setDate(props.date.toDate());
      var input = dateInputRef.current;
      input.setSelectionRange(0, input.value.length);
      if (isString(value)) {
        setPreviousValue(value);
      }
    },
    onBlur: function onBlur(e) {
      if (previousValue) {
        var inferredData = inferDate(value, date);
        var isExceedingMaxDate = maxDate && new Date(inferredData).getTime() > new Date(maxDate).getTime();
        var isSubceedingMinDate = minDate && new Date(inferredData).getTime() < new Date(minDate).getTime();
        if (isExceedingMaxDate || isSubceedingMinDate) {
          setValue(previousValue);
          setDate(inferDate(previousValue, date));
          setPreviousValue(null);
          return;
        }
      }
      if (!calendarRef.current.contains(e.relatedTarget)) {
        setShowCalendar(false);
        if (previousValue !== null && value !== previousValue) {
          updateDate();
          onInputChange(value);
        }
        setPreviousValue(null);
      }
    },
    onChange: function onChange(_ref4) {
      var value = _ref4.currentTarget.value;
      setValue(value);
      setDate(inferDate(value, date));
    },
    inputProps: {
      onKeyDown: onEnter(function () {
        return updateDate();
      }),
      autoComplete: "off"
    },
    error: !hasFocus && props.error
  }), props.showTime && /*#__PURE__*/React.createElement(TimeSelect, {
    disabled: props.disabled,
    date: date,
    value: minutes,
    onChange: function onChange(minutes) {
      setMinutes(minutes);
      if (hasDate) {
        _onChange(props.date.clone().set(getHoursAndMinutes(minutes)));
      }
    }
  })), /*#__PURE__*/React.createElement(CalendarDisplay, {
    ref: calendarRef,
    show: showCalendar,
    selectedDate: hasDate ? props.date.toDate() : new Date(),
    date: date,
    minDate: minDate,
    maxDate: maxDate,
    onChange: function onChange(date) {
      updateDate(date, true);
      setShowCalendar(false);
    },
    prevMonth: function prevMonth() {
      return setDate(addMonths(date, -1));
    },
    nextMonth: function nextMonth() {
      return setDate(addMonths(date, 1));
    },
    alwaysShowCalendar: alwaysShowCalendar
  }));
}
DatePicker.TimeSelect = TimeSelect;
//# sourceMappingURL=DatePicker.js.map